import dayjs, { Dayjs } from 'dayjs'

export const useDateFormatter = () => {
  const { t, locale } = useI18n()
  
  const df = {
    w: 'dddd,',
    d: 'D',
    m: 'MMM',
    t: locale.value === 'en' ? 'h:mm A' : 'HH:mm',
  }

  function isToday(date: Dayjs) {
    return dayjs().isSame(date, 'day')
  }

  function isTomorrow(date: Dayjs) {
    return dayjs().add(1, 'day').isSame(date, 'day')
  }

  function formatDateLabel(date: Dayjs, time = true) {
    const dateFormat = `${df.d} ${df.m}`;
    const fullFormat = time ? `${dateFormat} · ${df.t}` : dateFormat;

    if (isToday(date)) {
      return `${t('common.today')}, ${date.format(fullFormat)}`;
    }
    
    if (isTomorrow(date)) {
      return `${t('common.tomorrow')}, ${date.format(fullFormat)}`;
    }

    const weekdayFormat = time ? `${df.w} ${dateFormat} · ${df.t}` : `${df.w} ${dateFormat}`;
    return date.format(weekdayFormat);
  }

  return {
    df,
    isToday,
    isTomorrow,
    formatDateLabel
  }
}